import React from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { publicRoutes } from "./RouteFile";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import Layout from "../Layout/Layout";

const Mainnavigation = () => {
  const Layouts = () => {
    return (
      <div className="contentContainer">
        <Layout>
          <Outlet />
        </Layout>
      </div>
    );
  };
  return (
    <>
      <BrowserRouter basename="/studentcafe">
        <ScrollToTop />
        <Routes>
          <Route element={<Layouts />}>
            {publicRoutes?.map((route) => (
              <Route
                key={route?.path}
                path={route?.path}
                element={route?.element}
              />
            ))}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default Mainnavigation;
